import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { log } from "node:console";
import { MerchantIdTitle } from "src/app/models/merchantIdTitle";
import { DataExchangeService } from "src/app/services/dataExchange.service";
import { GetMerchantForUserService } from "src/app/services/getMerchantForUser.service";
import { LoginService } from "src/app/services/login.service";
import { SignalRService } from "src/app/services/signalR.service";

@Component({
  selector: "app-usernav",
  templateUrl: "./usernav.component.html",
  styleUrls: ["./usernav.component.css"],
})
export class UsernavComponent implements OnInit, OnChanges {
  @Input() showMenu!: boolean;
  @Output() onShowMenu = new EventEmitter<boolean>();
  @Output() onMenuTemplateRender = new EventEmitter<TemplateRef<any>>();

  merchants: MerchantIdTitle[];
  checkAM: boolean;
  checkRU: boolean;
  checkEN: boolean;
  selectedMerchant: MerchantIdTitle;
  logo: string = "";
  merchant: any;

  showSmMenu: boolean = false;
  showLangMenu: boolean = false;

  currentLang: string;

  waitingForLogOut: boolean = false;
  showLogo = false;

  constructor(
    private dataEx: DataExchangeService,
    private getMerFUser: GetMerchantForUserService,
    private translate: TranslateService,
    private router: Router,
    private signalRService: SignalRService,
    private loginService: LoginService
  ) {
    let lang = localStorage.getItem("lang");

    if (lang == "en") this.currentLang = "ENG";
    else if (lang == "ru") this.currentLang = "РУС";
    else this.currentLang = "ՀԱՅ";
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.evaluateLogo();
  }

  ngOnInit() {
    this.signalRService.startConnection(localStorage.getItem("token"));
    setTimeout(() => {
      this.signalRService.listenerWS();
    }, 1000);

    this.signalRService.startConnectionLoginHub(localStorage.getItem("token"));
    setTimeout(() => {
      this.signalRService.listenerLoginHub((data) => {
        localStorage.removeItem("token");
        localStorage.removeItem("id");
        this.router.navigateByUrl("/");
      });
    }, 2500);

    this.checkAM = localStorage.getItem("lang") == "am" ? true : false;
    this.checkRU = localStorage.getItem("lang") == "ru" ? true : false;
    this.checkEN = localStorage.getItem("lang") == "en" ? true : false;
    this.translate.use(localStorage.getItem("lang"));
    const get_id_promise = new Promise((reslove, reject) => {
      let id = localStorage.getItem("id");
      reslove(id);
    });
    get_id_promise.then((data) => {
      this.getMerFUser.getMerchantUser(data).subscribe((res) => {
        this.merchants = res["merchants"];
        let sginalRMerchantId = res["merchantUserId"];
        this.signalRService.addData(sginalRMerchantId);

        this.merchant = res;
        this.logo;
        this.selectedMerchant = this.merchants[0];
        this.dataEx.setMerId(this.merchants[0].id);
        this.evaluateLogo();
      });
    });
  }
  change(id: number) {
    this.selectedMerchant = this.merchants.filter((elem) => elem.id == id)[0];
    if (this.merchants.length == 1) this.dataEx.setMerId(this.merchants[0].id);
    else this.dataEx.setMerId(id);

    let merObject = this.merchants.find((e) => e.id == id);
    this.dataEx.updateMerchantTr(merObject);
    this.dataEx.setMerId(id);
  }
  changeLang(lang: string) {
    if (lang == "en") this.currentLang = "ENG";
    else if (lang == "ru") this.currentLang = "РУС";
    else this.currentLang = "ՀԱՅ";

    this.checkAM = lang == "am" ? true : false;
    this.checkRU = lang == "ru" ? true : false;
    this.checkEN = lang == "en" ? true : false;
    localStorage.setItem("lang", lang);
    this.translate.use(lang);
  }
  logout() {
    this.waitingForLogOut = true;
    this.loginService
      .logoutMerchant()
      .toPromise()
      .then((success) => {
        localStorage.removeItem("token");
        localStorage.removeItem("id");
        localStorage.removeItem("tokenr");
        this.waitingForLogOut = false;
        this.router.navigateByUrl("");
      })
      .catch((err) => {});
  }
  chPass() {
    this.router.navigate(["change-password"]);
  }

  changeMerchantLogo(path: string): boolean {
    if (path == "" || !path || path.includes("online.payx.am")) return false;
    return true;
  }

  toggleMenu(template: TemplateRef<any>) {
    this.showMenu = !this.showMenu;
    this.onShowMenu.emit(this.showMenu);
    this.onMenuTemplateRender.emit(template);
    if (this.showMenu) {
      this.showSmMenu = false;
    }
  }

  toggleLangList() {
    this.showLangMenu = !this.showLangMenu;
  }

  showSmallMenu() {
    this.showSmMenu = !this.showSmMenu;
    if (this.showSmMenu) {
      this.showMenu = false;
      this.onShowMenu.emit(this.showMenu);
    }
  }

  evaluateLogo() {
    const logo = this.merchant?.merchantInfo?.logo;
    this.showLogo = !!logo && logo !== "" && !logo.includes("online.payx.am");
  }

  onError() {
    this.showLogo = false;
  }

  @HostListener("document:click", ["$event"])
  onClickOutside(event: Event): void {
    const targetElement = event.target as HTMLElement;

    // Check if the click is outside the .lang element
    // if (!targetElement.closest(".lang")) {
    //   this.showLangMenu = false;
    // }

    if (!targetElement.closest(".menu-small")) {
      this.showSmMenu = false;
    }
  }
}
